import type { IGatsbyImageData } from 'gatsby-plugin-image';

import Image from '@klv/atoms/image';
import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/productsCardFullWidth.module.scss';
import type { IProductsCardFullWidth } from './types';

export const ProductsCardFullWidth = ({
  buttonText,
  buttonUrl, 
  className = '',
  desktopImage,
  mobileImage, 
  text,
}: IProductsCardFullWidth) =>  (

  <a 
    className={generateClassName([className, 'grid', styles.productsCardFullWidth])}
    tabIndex={0}
    aria-label={`text: ${text}, image: ${desktopImage.altText}`}
    href={buttonUrl}
  >
    <div className={styles.cardContentContainer}>
      <div className={styles.styledButton}>
        {buttonText}
      </div>  
      <div className={styles.subHeadline}>
        {text}
      </div>
    </div>
    <div className={styles.imageContainer}>
      <Image className={styles.cardDesktopImage} imageData={desktopImage.gatsbyImage as IGatsbyImageData} altText={desktopImage?.altText} />
      <Image className={styles.cardMobileImage} imageData={mobileImage.gatsbyImage as IGatsbyImageData} altText={mobileImage?.altText} />
    </div>
  </a>
);

